const validationMessage = 'Required';

export const validateRequired = (value, message = validationMessage) => {
  const checkValue = Array.isArray(value) ? value.length : value;
  return checkValue ? undefined : message;
};

export const ftpUrl = value =>
  /^ftp:\/\/.*:\d+/gi.test(value) ? undefined : 'Non FTP URL';
